import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const LIVE_EVENTS = [
  {
    id: 1,
    title: "Live: Real Estate Q&A with Priya Sharma",
    time: "Today at 7:00 PM EST",
    attendees: 89,
    isLive: true,
    type: "webinar",
  },
  {
    id: 2,
    title: "Upcoming: Stock Market Sisters Masterclass",
    time: "Mar 10 at 6:00 PM EST",
    attendees: 156,
    isLive: false,
    type: "masterclass",
  },
];

export default function LiveEventBanner() {
  const [dismissed, setDismissed] = useState(false);
  const [eventIdx, setEventIdx] = useState(0);

  if (dismissed) return null;
  const event = LIVE_EVENTS?.[eventIdx];

  return (
    <div className="rounded-xl p-3 flex items-center gap-3 border" style={{ background: event?.isLive ? 'rgba(220,38,38,0.05)' : 'rgba(27,42,94,0.04)', borderColor: event?.isLive ? 'rgba(220,38,38,0.2)' : 'var(--color-border)' }}>
      <div className="flex-shrink-0">
        {event?.isLive ? (
          <div className="flex items-center gap-1.5 px-2 py-1 rounded-full" style={{ background: '#DC2626' }}>
            <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
            <span className="font-caption text-xs font-bold text-white">LIVE</span>
          </div>
        ) : (
          <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ background: 'rgba(27,42,94,0.1)' }}>
            <Icon name="Calendar" size={15} color="var(--color-primary)" />
          </div>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-caption text-xs font-semibold truncate" style={{ color: 'var(--color-foreground)' }}>{event?.title}</p>
        <div className="flex items-center gap-2 mt-0.5">
          <span className="font-caption text-xs" style={{ color: 'var(--color-muted-foreground)' }}>{event?.time}</span>
          <span className="font-caption text-xs" style={{ color: 'var(--color-muted-foreground)' }}>· {event?.attendees} attending</span>
        </div>
      </div>
      <div className="flex items-center gap-1 flex-shrink-0">
        <Button variant="default" size="xs" onClick={() => {}}>
          {event?.isLive ? 'Join Now' : 'RSVP'}
        </Button>
        <button onClick={() => setDismissed(true)} className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors">
          <Icon name="X" size={13} color="var(--color-muted-foreground)" />
        </button>
      </div>
    </div>
  );
}